import type { CardType } from 'lib-shared-types-api';

import { CardTypeExternal } from '../../../../cards.types';
import type {
  AvailableParameter,
  ExternalIntegrationParameters,
  HookParameter,
} from '../cardsTest.types';

/**
 * Returning parameters depending on the card-type. External integration cards
 * only support a limited list of parameters while `custom` cards support all
 * parameters.
 */
export const getAvailableParameters = (
  cardType: CardType,
): AvailableParameter[] => {
  const parameters = hookUrlParameters.map((item) => ({
    id: item.id,
    name: `{{ ${item.id} }}`,
  }));

  if (cardType in externalIntegrations) {
    return parameters.filter((item) =>
      externalIntegrations[cardType].includes(item.id),
    );
  }

  return parameters;
};

/**
 * Not all cards support all available hook parameters. All external cards are
 * limited to these.
 */
export const externalIntegrationsParameters: readonly ExternalIntegrationParameters[] =
  ['a_email', 'b_email', 'a_phone_number', 'b_phone_number'];

/** Mapping external card integrations to limited parameters */
export const externalIntegrations: Record<CardTypeExternal, readonly string[]> =
  {
    shopify: externalIntegrationsParameters,
    salesforce: externalIntegrationsParameters,
    magento: externalIntegrationsParameters,
  };

/**
 * Represents all possible hook variables with description. This will be removed
 * once TEAMS-6653 is done. Then we will fetch this dynamically from an
 * enpoint.
 */
export const hookUrlParameters: readonly HookParameter[] = [
  { id: 'calling_phone_number', description: 'Calling phone number' },
  { id: 'called_phone_number', description: 'Called phone number' },
  { id: 'customer_phone_number', description: 'Customer phone number' },
  { id: 'agent_phone_number', description: 'Agent phone number' },
  { id: 'widget_id', description: 'Widget ID' },
  { id: 'facebook_page_id', description: 'Facebook page ID' },
  { id: 'sending_email', description: 'Sending email' },
  { id: 'receiving_email', description: 'Receiving email' },
  { id: 'agent_email', description: 'Agent email' },
  { id: 'customer_email', description: 'Customer email' },
  {
    id: 'a_phone_number',
    description: "Caller's phone number (typical user's number).",
  },
  {
    id: 'b_phone_number',
    description: 'The receivers number (typical your organization number).',
  },
  { id: 'a_email', description: 'The senders email address.' },
  { id: 'b_email', description: "The receiver's email address." },
  { id: 'csid', description: 'The conversation id in Dixa.' },
  { id: 'customer_external_id', description: 'Customer external ID' },
];
